import { render, staticRenderFns } from "./NewPasswordDialog.vue?vue&type=template&id=63756b9e&scoped=true&"
import script from "./NewPasswordDialog.vue?vue&type=script&lang=js&"
export * from "./NewPasswordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63756b9e",
  null
  
)

export default component.exports